const FETCH_QUERY = `
  query {
    listDevices(pagination: {
      page: 1,
      perPage: 10,
    }) {
      objects {
        name
        isBypass
        isOnline
      }
    }
    listUsers(pagination: {
      page: 1,
      perPage: 10,
    }) {
      objects {
        username
        cards {
          isBypass
        }
      }
    }
    listSchedules(pagination: {
      page: 1,
      perPage: 10,
    }) {
      objects {
        uuid
      }
    }
    listSchedules(pagination: {
      page: 1,
      perPage: 10,
    }) {
      objects {
        uuid
      }
    }
    listSettings {
      authenticator
    }
  }
`

const gettingStartedQueries = {
  methods: {
    async fetchGuideItems() {
      try {
        const _result = await this.graphQuery(FETCH_QUERY)
        return _result
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default gettingStartedQueries
